import React from 'react';

import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Erro404 from './pages/Erro404';
import { isAuthenticated } from './services/auth';
import Solucoes from './pages/Solucoes';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/cliente", state: { from: props.location } }} />
        )
      }
    />
);

function Routes() {
  let url = process.env.NODE_ENV !== 'development' ? process.env.PUBLIC_URL : '';
  return(
      <BrowserRouter>
        <Switch>
            <Route path={`${url}/`} exact component={Login}/>
            <Route path={`${url}/login`} exact component={Login}/>
            <PrivateRoute path={`${url}/home`} component={Home}/>
            <Route path={`${url}/solucoes`} component={Solucoes}/>
            <Route path={`${url}/*`} component={Erro404} />
          </Switch>
      </BrowserRouter>
  );
}

export default Routes;